<template>
    <div class="back-button-block">
        <div class="back-button" @click="clickHandler">
            <awesome-icon name="arrow-left" noMargin />
        </div>
        돌아가기
    </div>
</template>
<script>
export default {
    name: "BackButton",
    methods: {
        clickHandler() {
            this.$emit("click");
        }
    }
};
</script>
<style lang='scss'>
@import "~styles/utils";

.back-button-block {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
}

.back-button {
    display: inline-flex !important;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);
    margin-right: 1.2rem;
    font-size: 1.6rem;

    svg {
        cursor: pointer;
        color: $primary;
    }
}
</style>